import { seoOgTwitterSite } from './SeoStore';

export const updateSeoOgTwitterSite = (value) => seoOgTwitterSite.update(oldValue => value);
